import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'ru', label: 'RU' },
  ];

  const currentLang = i18n.language?.substring(0, 2) || 'en';

  return (
    <div className={`flex items-center ${className}`}>
      {languages.map((lang, index) => (
        <React.Fragment key={lang.code}>
          <button
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`px-3 py-2 text-sm tracking-wide transition-all duration-300 ${
              currentLang === lang.code
                ? 'text-[#B8963E] font-medium'
                : 'text-[#8B7E6A] hover:text-[#3D3831]'
            }`}
            aria-label={`Switch to ${lang.label}`}
            style={{ minHeight: '44px', minWidth: '44px' }}
          >
            {lang.label}
          </button>
          {index < languages.length - 1 && (
            <span className="text-[#E8E2D9]">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
